import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchSortBy } from '@uncinc/react-searchkit';
import type { SearchSortByProps } from '@uncinc/react-searchkit/dist/components/SortBy';

import { APP_OPTIONS } from '../../../config/constants';
import { sorting } from '../config';

import './style.scss';

const SearchAllContentSortBy: React.FC<Omit<SearchSortByProps, 'inputType' | 'items'>> = (props) => {
  const { className, ...restProps } = props;

  const { t } = useTranslation();

  const classes = classNames('SearchAllContent__SortBy', className);

  const items = useMemo(() => (
    Object.entries(sorting).map(([key, sortingOption]) => {
      const sort = Array.isArray(sortingOption) ? sortingOption[0] : sortingOption;
      const sortKey = sort?.field ? `${sort.field}_${sort.order}` : '_score_asc';

      return {
        label: t(`searchkit.sort_by.items.${sortKey}`),
        value: `${APP_OPTIONS.parameters.searchkitIndexAllContent}${key !== 'default' ? key : ''}`,
      };
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ), []);

  return (
    <div className={classes}>
      <SearchSortBy
        {...restProps}
        inputType="select"
        // @ts-expect-error
        title={t('searchkit.sort_by.title')}
        isSearchable={false}
        className="Select__inner"
        items={items}
      />
    </div>
  );
};

export default SearchAllContentSortBy;
